import { Clock } from "lucide-react";

import { orEmptyValue } from "@/lib/hcbb-cost-estimator-utils";
import {
  HCBB_DETAIL_HEADING_ID,
  HcbbDetailAddress,
  HcbbDetailHeader,
  HcbbDetailLine,
} from "@/pages/components/hcbb-cost-estimator/hcbb-detail-header";
import { HcbbPhoneButton } from "@/pages/components/hcbb-cost-estimator/hcbb-phone-button";
import type { HcbbFacilityResult } from "@/model/hcbb-cost-estimator";

/**
 * Everything the estimate knows about one facility.
 *
 * No "accepting new patients" here, unlike a provider: the facility payload
 * carries no such field, and a badge every facility showed regardless would be
 * a claim about care that nothing backs.
 */
export const HcbbFacilitySummary = ({
  facility,
}: {
  facility: HcbbFacilityResult;
}) => (
  <section
    aria-labelledby={HCBB_DETAIL_HEADING_ID}
    className="border-1 border-gray space-y-6 rounded-lg border p-6 shadow-md"
  >
    <HcbbDetailHeader
      title={facility.displayName}
      actions={
        <HcbbPhoneButton name={facility.displayName} phone={facility.phone} />
      }
    >
      <HcbbDetailAddress
        address={facility.address}
        displayRadius={facility.displayRadius}
      />
      <HcbbDetailLine icon={Clock}>
        {orEmptyValue(facility.hours)}
      </HcbbDetailLine>
    </HcbbDetailHeader>
  </section>
);
